<template src="./ThankYouPage.template.html"></template>
<script>
    import moment from "moment-timezone";
    import VeeValidate from "vee-validate";
    Vue.use(VeeValidate);
    import Vue from "vue";

    export default {
        name: "ThankYouPage",
        props: [],

        data() {
            return {
                apiUrl: window.location.protocol + '//' + window.location.hostname + (window.location.port ? ":1339" : ''),
                folioItemCharges: [],
                folioCharges: {},
                selectedUnit: {},
                guestInfo: {},
                hashUrlReservationId: -1,
                showAuthentication: false,
                email: null,
                ccLast4Digits: null,
                invalidData: null,
                showPriceInfo: false,
                showPriceText: "Details",
                isWebView: null,
                filterObj: {
                    value: [null, null],
                    Persons: -99,
                    Adults: -99,
                    Children: -99,
                    startDate: null,
                    endDate: null,
                    Location: -99,
                    ClientId: 7,
                    FilteredAmenities: [],
                    amenitiesFiltered: [],
                    Beds: 0,
                    Bathrooms: 0,
                    Beds: 0,
                    Bedrooms: 0,
                    PageNo: 1,
                    ItemsPerPage: 20,
                    unitId: null
                },
            }

        },
        methods: {
            showPriceDetails() {
                this.showPriceInfo = !this.showPriceInfo;
                if (this.showPriceInfo) {
                    this.showPriceText = "Close"
                } else {
                    this.showPriceText = "Details"
                }

            },
            navigateToHomePage() {
                // window.localStorage.setItem("component", "thankyou");
                let vm = this;
                vm.filterObj.Persons = vm.$store.state.filterObj.Persons
                vm.filterObj.Adults = vm.$store.state.filterObj.Adults
                vm.filterObj.Children = vm.$store.state.filterObj.Children
                vm.filterObj.Location = vm.$store.state.filterObj.Location
                vm.$store.dispatch("setAvailableUnitsData", {
                    data: {
                        filterObj: JSON.parse(JSON.stringify(vm.filterObj)),
                    }
                })
                vm.$store.state.bus.$emit("updateSearchData", vm.filterObj);
                vm.$router.push("/");
            },
            formatMoney(amount) {
                return this.$store.state.getFormattedAmount("$", amount);
            },
            formatDate(date) {
                return moment(date, "YYYY-MM-DD").format("DD MMM ");
            },
            imageURLS(imgGuid) {
                let isBase64 = /^data:image\/([a-zA-Z]*);base64,([^\"]*)/.test(imgGuid)
                if (isBase64) {
                    return imgGuid;
                }
                return this.apiUrl + '/downloadImage/' + imgGuid + '/430x300';
            },
            formatEndDate(date) {
                let vm = this;
                let startYear = moment(vm.$store.state.filterObj.startDate, "YYYY-MM-DD").format("YYYY");
                let endYear = moment(vm.$store.state.filterObj.endDate, "YYYY-MM-DD").format("YYYY");
                return moment(date, "YYYY-MM-DD").format("DD MMM YYYY");
            },
            formatStartDate(date) {
                let vm = this;
                let startYear = moment(vm.$store.state.filterObj.startDate, "YYYY-MM-DD").format("YYYY");
                let endYear = moment(vm.$store.state.filterObj.endDate, "YYYY-MM-DD").format("YYYY");

                if (startYear == endYear) {
                    return moment(date, "YYYY-MM-DD").format("DD MMM ");
                }
                else {
                    return moment(date, "YYYY-MM-DD").format("DD MMM YYYY");
                }
            },
            GetReservationDetailById: function () {
                let vm = this;
                console.log("vm.hashUrlReservationId======?", vm.hashUrlReservationId);
                let obj = {
                    ModuleAction: "GetReservationDetailById",
                    ReservationId: vm.hashUrlReservationId,
                    BE_Id: null
                };
                let sucessCallback = function (response) {
                    if (response.data) {
                        console.log("GetReservationDetailById", response.data);
                        vm.guestInfo = response.data.guestInfo;
                        console.log("vm.guestInfo", vm.guestInfo);
                        if (response.data.roomInfo.UnitId) {
                            vm.selectedUnit = response.data.roomInfo;
                        }
                    }
                },
                    failureCallback = function (error) {
                        console.log(error);
                    };
                vm.$store.state.sendApiRequest("beApi/GetReservationDetailById", "post", obj, sucessCallback, failureCallback);
            },

            Get_FolioSummary: function () {
                let vm = this;
                let obj = {
                    ModuleAction: "Get_FolioSummary",
                    ReservationId: vm.hashUrlReservationId,
                };
                let sucessCallback = function (response) {

                    if (response.data) {
                        vm.folioItemCharges = response.data[0];
                        vm.folioCharges = response.data[2][0];
                        console.log("Get_FolioSummary", response.data);
                    }
                },
                    failureCallback = function (error) {
                        console.log(error);
                    };
                vm.$store.state.sendApiRequest("beApi/Get_FolioSummary", "post", obj, sucessCallback, failureCallback);
            },
            GetReservationDetailsByURL() {
                let vm = this,

                    obj = {
                        confirmationNumber: decodeURIComponent(vm.$route.params.confirmationNumber)
                    };
                console.log("vm.$route.params.confirmationNumber", vm.$route.params.confirmationNumber)

                let sucessCallback = function (response) {
                    console.log("response in getPaymentCardDetails", response);
                    if (response && response.data && response.data.recordsets[0] && response.data.recordsets[0][0]) {

                        vm.hashUrlReservationId = response.data.recordsets[0][0].ReservationId;
                        vm.GetReservationDetailById();
                        vm.Get_FolioSummary();

                    } else {
                        vm.hashUrlReservationId = -1
                        vm.GetReservationDetailById();
                        vm.Get_FolioSummary();
                    }

                },
                    failureCallback = function (error) {
                        console.log(error);
                    };

                vm.$store.state.sendApiRequest("beApi/GetReservationDetailsByURL", "post", obj, sucessCallback, failureCallback);
            },
            Autenticate_user() {
                let vm = this;
                let obj = {
                    ReservationId: vm.hashUrlReservationId,
                    EmailAddress: vm.email,
                    Last4: vm.ccLast4Digits
                };

                let sucessCallback = function (response) {
                    console.log("response in Autenticate_user", response);
                    if (response && response.data && response.data[0] && response.data[0][0]) {
                        vm.showAuthentication = false;
                        vm.invalidData = null
                        if (vm.$route.params.email && vm.$route.params.email == 'email') {
                            Cookies.remove('emailIdleTime');
                            var date = new Date();
                            date.setTime(date.getTime() + (30 * 60 * 1000));
                            Cookies.set('emailIdleTime', vm.$route.params.confirmationNumber, { expires: date });
                        }
                        else {
                            Cookies.remove('idleTime');
                            var date = new Date();
                            date.setTime(date.getTime() + (30 * 60 * 1000));
                            Cookies.set('idleTime', vm.$route.params.confirmationNumber, { expires: date });
                        }
                    } else {
                        vm.invalidData = "Unauthorized Access!!"
                    }
                },
                    failureCallback = function (error) {
                        console.log(error);
                    };

                vm.$store.state.sendApiRequest("beApi/Autenticate_user", "post", obj, sucessCallback, failureCallback);

            },
            initGMapWidth() {
                this.$nextTick(this.resizeEvent);
                window.addEventListener("resize", this.resizeEvent);
                // this.isLoading = false;
            },
            resizeEvent() {
                if (!this.$refs.thankYouInfo) {
                    return;
                }
                let vm = this;
                let cw = this.$refs.thankYouInfo.clientWidth;
                console.log("^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^", cw);

                if (cw <= 797 && cw != "768") {
                    console.log("mmmmmmmmmmmmmmmmmmmmmmmmmm")
                    vm.isWebView = false;
                }
                else {
                    console.log("wwwwwwwwwwwwwwwwwwwwwwwwwwwww")
                    vm.isWebView = true;
                }
            },
            routeChangeEvent() {
                let vm = this;
                if(vm.$gtag){
                    vm.$gtag.pageview({
                        page_title: 'Thank You-Page',
                        page_location: window.location.href,
                        page_path: vm.$route.path,
                    })
                }
            }
        },
        computed: {
            isVaildSubDomain() {
                let vm = this;
                return vm.$store.state.isValidDomainOrNot;
            },
            mapWraperLoaded() {
                return this.isVaildSubDomain;
            }
        },
        mounted() {
            let vm = this;
            vm.$store.state.bus.$emit("hidingSearch", false);
            setTimeout(() => {
                if(vm.$gtag){
                    vm.$gtag.pageview({
                        page_title: 'Thank You-Page',
                        page_location: window.location.href,
                        page_path: vm.$route.path,
                    })
                }
            }, 100)
            vm.GetReservationDetailsByURL();
            console.log("vm.$route.params.emailvm.$route.params.email", Cookies.get('idleTime'))
            if (vm.$route.params.email && vm.$route.params.email == 'email') {
                if (Cookies.get('emailIdleTime') == vm.$route.params.confirmationNumber) {
                    vm.showAuthentication = false;
                } else {
                    Cookies.remove('idleTime');
                    vm.showAuthentication = true;
                }
            } else {
                if (Cookies.get('idleTime') == decodeURIComponent(vm.$route.params.confirmationNumber)) {
                    vm.showAuthentication = false;
                } else {
                    vm.showAuthentication = true;
                }

            }

            // setTimeout(() => {
            //     this.resizeEvent();
            //     window.addEventListener('resize', this.resizeEvent);
            // }, 140)
            // this.GetReservationDetailById();
            // this.Get_FolioSummary();
            if (this.mapWraperLoaded) {
                this.initGMapWidth();
            }
            document.getElementById("page-content").style.padding = "";
        },
        watch: {
            mapWraperLoaded(newValue, oldValue) {
                console.log("newValue", newValue)
                if (newValue !== oldValue && newValue === true) {
                    this.initGMapWidth();
                }
            },
            isVaildSubDomain(isAvail) {
                if (isAvail) {
                    this.GetReservationDetailById();
                    this.Get_FolioSummary();
                    this.GetReservationDetailsByURL();
                }
            },
            $route: "routeChangeEvent"
        },
        created() {
            $("html, body").animate({ scrollTop: 0 });
        },
        beforeDestroy() {
            window.removeEventListener("resize", this.resizeEvent);
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/ThankYouPage/ThankYouPage.vue